import React, { ReactElement } from "react";

type IconProps = {
  width?: number;
  height?: number;
  className?: string;
};

export default function AlignTopIcon(props: IconProps): ReactElement {
  const { width = 24, height = 24, className = "" } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M19.2001 3.6001H4.8001C4.13736 3.6001 3.6001 4.13736 3.6001 4.8001V6.0001C3.6001 6.66284 4.13736 7.2001 4.8001 7.2001H19.2001C19.8628 7.2001 20.4001 6.66284 20.4001 6.0001V4.8001C20.4001 4.13736 19.8628 3.6001 19.2001 3.6001Z"
        fill="#A1A1A1"
      />
      <path
        d="M11.4241 8.68791L7.46412 13.9679C7.1082 14.4426 7.44684 15.1199 8.04012 15.1199H10.8001V20.3483C10.8001 20.9749 11.2583 21.5349 11.882 21.5944C12.5977 21.6628 13.2001 21.1017 13.2001 20.4001V15.1201H15.9601C16.5534 15.1201 16.892 14.4429 16.5361 13.9681L12.5761 8.68815C12.2881 8.30415 11.7121 8.30391 11.4241 8.68791Z"
        fill="#A1A1A1"
      />
    </svg>
  );
}
